export function moduleStateCopy(locale, status) {
  const index = /^en/i.test(locale) ? 2 : /Hant|TW|HK|MO/i.test(locale) ? 1 : 0
  return {
    loading: ['正在读取模块…', '正在讀取模組…', 'Loading module…'][index],
    title: (status === 404 ? ['此模块接口尚未接入', '此模組接口尚未接入', 'This module is not connected'] : ['暂时无法读取此模块', '暫時無法讀取此模組', 'This module is temporarily unavailable'])[index],
    description: (status === 404 ? ['当前服务未提供此旧模块接口，不影响赛事管理。请勿在此录入；接入后可重新读取。', '目前服務未提供此舊模組接口，不影響賽事管理。請勿在此錄入；接入後可重新讀取。', 'The current server does not provide this legacy module. Event management is unaffected. Reconnect the module before entering data.'] : ['请检查本地服务或网络后重试。没有修改任何数据。', '請檢查本地服務或網絡後重試。沒有修改任何資料。', 'Check the local service or connection and retry. No data was changed.'])[index],
    retry: ['重新读取', '重新讀取', 'Retry'][index]
  }
}
